
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Bestpginhinjewadiphase() {



    const cardData =
    {
        keyword: 'Best PG in Hinjewadi Phase 1 for Females with Food Near Infosys ',
        heading: 'Shree Swami Samarth PG: Best PG in Hinjewadi Phase 1 for Females with Food Near Infosys ',
        headingDescription: 'Shree Swami Samarth PG offers the best PG in Hinjewadi Phase 1 for females with food near Infosys, ensuring a safe, comfortable, and homely stay for working women and students. Located just minutes away from Infosys and other leading IT companies, our PG provides excellent connectivity, reducing daily travel time and making it highly convenient for professionals. The rooms are fully furnished, spacious, and designed with a focus on privacy and comfort, including study-friendly setups and secure access. Residents enjoy hygienic home-cooked meals served three times a day, along with essential amenities like high-speed WiFi, 24x7 water supply, CCTV surveillance, and disciplined management to ensure safety at all times. With regular housekeeping, a peaceful environment, and affordable rent packages, Shree Swami Samarth PG in Hinjewadi Phase 1 is the ideal choice for females seeking reliable, food-inclusive, and secure accommodation near Infosys.',

        top: 'Top Facilities at Shree Swami Samarth PG ',

"topFacilities": [
  {
    "title": "Furnished Rooms Designed for Women",
    "description": "Female PGs in Hinjewadi Phase 1 near Infosys offer fully furnished and neatly maintained rooms equipped with beds, wardrobes, study desks, and chairs. Options like single and twin sharing ensure both affordability and privacy. Interiors are bright, airy, and thoughtfully arranged to provide comfort after long working hours. Many PGs also feature attached bathrooms or balconies for added convenience. These setups create a homely yet professional environment, making them ideal for female IT employees and students."
  },
  {
    "title": "Nutritious Meals Included in Rent",
    "description": "One of the biggest advantages of female PGs near Infosys is the inclusion of daily, freshly cooked meals. Residents are served breakfast, lunch, and dinner with balanced menus focusing on both taste and nutrition. Kitchens maintain strict hygiene practices, and special dietary needs like vegetarian-only options are also catered to. This food-inclusive system saves valuable time for busy professionals who don’t have to rely on outside food daily. It provides both convenience and health assurance for working women."
  },
  {
    "title": "High-Speed Wi-Fi and Work-Friendly Setup",
    "description": "Female PGs in Hinjewadi Phase 1 are equipped with reliable high-speed Wi-Fi to support professional and academic needs. Residents can smoothly attend online meetings, complete office projects, or prepare study material without interruptions. Some PGs also provide quiet study or co-working lounges with charging points and proper lighting. Combined with reliable power backup, these facilities make PGs near Infosys perfectly suited for women working in IT who often require flexible hours and digital access."
  },
  {
    "title": "24/7 Security and Safe Women-Friendly Environment",
    "description": "Safety is the top priority in PGs designed for women near Infosys. CCTV surveillance, biometric entry, female wardens, and round-the-clock staff ensure residents’ security. Visitor entry is carefully monitored, providing a safe and disciplined environment. Located in secure residential communities of Hinjewadi Phase 1, these PGs give peace of mind to both residents and their families. Women professionals working late shifts at Infosys can return confidently to a secure and welcoming place."
  },
  {
    "title": "Prime Location Next to Infosys Campus",
    "description": "These PGs are strategically located within walking distance or a short ride from Infosys in Hinjewadi Phase 1. This saves significant commuting time and energy for professionals, allowing them to maintain a healthier work-life balance. Proximity to Phase 1 IT Park also means easy access to other companies like Wipro, Cognizant, and TCS. The locality is well-developed with gyms, supermarkets, cafés, and shopping hubs, ensuring daily essentials are always nearby."
  },
  {
    "title": "Daily Housekeeping and Laundry Services",
    "description": "Most PGs for women in Hinjewadi Phase 1 include professional housekeeping that keeps rooms and bathrooms clean on a daily basis. Garbage disposal and sanitation routines ensure hygienic living conditions. Laundry services are also available—either in-house or via partner facilities—making life easier for busy professionals. These services help residents focus on their jobs and personal time without worrying about household chores. Clean surroundings contribute directly to comfort and peace of mind."
  },
  {
    "title": "Recreational and Community Living",
    "description": "Beyond accommodation, women’s PGs near Infosys also focus on community and leisure. Common lounges, TV rooms, and indoor games allow residents to relax after work hours. Shared dining and cultural celebrations create a friendly, interactive atmosphere. These PGs often encourage bonding among professionals working in different IT companies, helping newcomers to the city feel connected. Recreation, combined with safety, ensures a balanced lifestyle for female residents."
  },
  {
    "title": "Affordable and Transparent Rent Packages",
    "description": "Female PGs in Hinjewadi Phase 1 near Infosys are available at competitive prices, with clear and transparent rent structures. Twin-sharing rooms with food typically start from ₹6,000–₹8,000/month, while premium single occupancy options range between ₹12,000–₹15,000/month. Packages usually include meals, Wi-Fi, housekeeping, and security, making them cost-effective for working women. With no hidden charges, residents and their families can plan expenses confidently. This makes these PGs a practical yet premium choice for women professionals."
  }
],


"services": [
  {
    "name": "Best PG for Females in Hinjewadi Phase 1",
    "description": "Shree Swami Samarth PG offers the best PG experience for females in Hinjewadi Phase 1. Our women-friendly PG combines comfort, safety, and convenience with daily meals, fully furnished rooms, high-speed internet, and female wardens. Perfect for professionals and students working or studying in the tech zone."
  },
  {
    "name": "PG Near Infosys Hinjewadi for Girls",
    "description": "Located just minutes from Infosys Campus, our PG for girls offers secure, well-managed living spaces in Hinjewadi Phase 1. Shree Swami Samarth PG includes cozy rooms, food, Wi-Fi, and a peaceful setting—ideal for female employees or interns at Infosys and nearby tech companies."
  },
  {
    "name": "Ladies PG with Food in Hinjewadi Phase 1",
    "description": "Enjoy nutritious and hygienic meals at our Ladies PG in Hinjewadi Phase 1. Shree Swami Samarth PG offers both veg and non-veg food options along with furnished rooms, daily housekeeping, and a home-like environment for women living near major IT offices."
  },
  {
    "name": "Safe PG for Women Near Infosys Hinjewadi",
    "description": "Safety is our top priority at Shree Swami Samarth PG for women near Infosys Hinjewadi. Our property features 24/7 CCTV surveillance, biometric access, and dedicated female staff. Perfect for girls seeking secure and respectful accommodation while working in the tech zone."
  },
  {
    "name": "Girls PG with Food Near Infosys Pune",
    "description": "Our Girls PG with Food near Infosys, Pune offers delicious home-cooked meals along with comfortable rooms, Wi-Fi, and all-inclusive rent plans. Shree Swami Samarth PG is ideal for female professionals and students seeking a balance of comfort, affordability, and proximity to work."
  },
  {
    "name": "Fully Furnished PG for Females in Phase 1 Hinjewadi",
    "description": "Move in with just your bag! Our PG for females in Hinjewadi Phase 1 comes fully furnished with beds, wardrobes, work desks, and attached washrooms. Shree Swami Samarth PG offers a complete hassle-free stay, ideal for busy professionals and interns at nearby companies."
  },
  {
    "name": "Affordable PG for Girls Near Infosys",
    "description": "Shree Swami Samarth PG provides affordable yet high-quality living for girls near Infosys in Hinjewadi. Our shared and single room options fit every budget and include food, Wi-Fi, security, and other essentials—making it a top choice for students and working professionals."
  },
  {
    "name": "PG with Veg/Non-Veg Food Near Infosys",
    "description": "Craving variety? Our PG near Infosys offers both veg and non-veg food options daily. Shree Swami Samarth PG ensures balanced, homemade meals along with clean living spaces and attentive support—perfect for female tenants who want food quality and flexibility."
  },
  {
    "name": "PG for Female Working Professionals in Phase 1",
    "description": "Shree Swami Samarth PG is designed to meet the lifestyle of female working professionals in Hinjewadi Phase 1. With high-speed Wi-Fi, study/work desks, home-cooked meals, and a peaceful ambiance, our PG supports productivity and relaxation just steps from your office."
  },
  {
    "name": "Girls Hostel Near Infosys Hinjewadi",
    "description": "Looking for a trusted girls hostel near Infosys Hinjewadi? Shree Swami Samarth offers a professionally managed, clean, and secure hostel with flexible rent options, food, and connectivity. Ideal for female interns, freshers, and long-term tech professionals."
  }
],
"tableData": [
  ["Best PG for Females in Hinjewadi Phase 1", "PG Near Infosys Hinjewadi for Girls"],
  ["Ladies PG with Food in Hinjewadi Phase 1", "Safe PG for Women Near Infosys Hinjewadi"],
  ["Girls PG with Food Near Infosys Pune", "Fully Furnished PG for Females in Phase 1 Hinjewadi"],
  ["Affordable PG for Girls Near Infosys", "PG with Veg/Non-Veg Food Near Infosys"],
  ["PG for Female Working Professionals in Phase 1", "Girls Hostel Near Infosys Hinjewadi"]
],




"whychoose": [
    {
        "WhyChooseheading": "Premium Girls PG Near Infosys – Safe, Clean & Comfortable",
        "WhyChoosedescription": "Shree Swami Samarth PG offers secure, fully furnished PG accommodations exclusively for women in Hinjewadi Phase 1. Located just minutes from Infosys and other IT companies, it combines comfort, convenience, and safety—ideal for working professionals and female students alike."
    },
    {
        "WhyChooseheading": "Walkable Distance from Infosys Campus",
        "WhyChoosedescription": "Strategically situated within walking or short commute distance from Infosys, Wipro, TCS, and other major tech parks, our PG helps you avoid long traffic delays and gives you more time to relax or focus on personal growth."
    },
    {
        "WhyChooseheading": "Delicious and Hygienic Food Included",
        "WhyChoosedescription": "We serve fresh, home-style meals three times a day—breakfast, lunch, and dinner. Both vegetarian and non-vegetarian options are available, with weekly menu variety and high kitchen hygiene standards to keep you healthy and energized."
    },
    {
        "WhyChooseheading": "Furnished AC Rooms with All Essentials",
        "WhyChoosedescription": "Rooms come with beds, wardrobes, private or shared washrooms, air conditioning, work desks, and strong Wi-Fi. Whether you choose single or shared occupancy, you get a clean, spacious, and peaceful environment designed for working women."
    },
    {
        "WhyChooseheading": "Women-Only Environment for Peace of Mind",
        "WhyChoosedescription": "Our female-only PG ensures a respectful, secure, and community-driven atmosphere. You’ll be living with like-minded women in a safe setting, away from unnecessary disturbances or concerns—perfect for focusing on your career or studies."
    },
    {
        "WhyChooseheading": "All-Inclusive Rent with Zero Hidden Charges",
        "WhyChoosedescription": "Enjoy complete peace of mind with an all-inclusive rental package. It covers stay, food, housekeeping, Wi-Fi, laundry, and electricity—no hidden charges or brokerage. Flexible rental terms also available for interns and short stays."
    },
    {
        "WhyChooseheading": "24/7 Security and Support Services",
        "WhyChoosedescription": "With round-the-clock security, CCTV monitoring, biometric access, and on-site female wardens, your safety is never compromised. Our support staff is also available 24/7 for maintenance, health emergencies, and general assistance."
    },
    {
        "WhyChooseheading": "Ideal for Working Women and Female Interns",
        "WhyChoosedescription": "Whether you're a full-time tech employee, a trainee, or a postgrad student doing an internship near Infosys, our PG is designed to match your pace. With calm surroundings, essential services, and easy accessibility, you’ll feel right at home."
    }
]





















    }

const faqData = [
    {
        question: "How can I book the best PG in Hinjewadi Phase 1 for females with food near Infosys?",
        answer: "You can book directly by calling us at +91 9594917913. We also offer online booking assistance and virtual tours for outstation residents."
    },
    {
        question: "Is your PG near Infosys Hinjewadi Phase 1 exclusively for female residents?",
        answer: "Yes, we have a separate, fully secure PG facility for female residents, located very close to Infosys and other major IT companies."
    },
    {
        question: "Is food included at your PG for females in Hinjewadi Phase 1?",
        answer: "Yes, we provide freshly prepared, hygienic vegetarian meals—breakfast, lunch, and dinner—all included in the rent."
    },
    {
        question: "What amenities do you offer at your female PG near Infosys, Hinjewadi Phase 1?",
        answer: "We provide furnished rooms, A/C options, high-speed Wi-Fi, laundry, daily housekeeping, attached bathrooms, biometric entry, and 24/7 CCTV surveillance."
    },
    {
        question: "How far is the PG from Infosys Hinjewadi Phase 1?",
        answer: "Our PG is within 5–10 minutes of Infosys campus, making it a convenient stay option for female employees and interns."
    },
    {
        question: "Is the PG environment safe and female-friendly?",
        answer: "Absolutely. We prioritize safety with 24/7 security, restricted male access, female wardens, and a zero-tolerance policy for disturbances."
    },
    {
        question: "What types of rooms are available for females in your Hinjewadi Phase 1 PG?",
        answer: "We offer single, double, and triple sharing rooms with attached washrooms and options for air-conditioned rooms."
    },
    {
        question: "Is transport available to Infosys or other companies nearby?",
        answer: "Our location is walkable or easily accessible via shared autos or bike taxis. Residents also opt for company transport."
    },
    {
        question: "What is the monthly rent for your female PG with food near Infosys?",
        answer: "Rent starts at affordable rates and varies by room type and facilities. Contact us directly for the best deals."
    },
    {
        question: "How do I contact Shree Swami Samarth PG to book the best PG near Infosys for females?",
        answer: "Call us at +91 9594917913 to check availability, schedule a visit, or confirm your booking."
    }
];

const testimonialsData = [
    {
        name: 'Ms. Neha Kulkarni',
        designation: 'Software Engineer, Infosys Hinjewadi Phase 1',
        rating: [1, 1, 1, 1, 1],
        text: '“This is hands-down the best PG for girls near Infosys. It’s clean, safe, and the food is better than any other place I’ve stayed in Pune.”',
    },
    {
        name: 'Ms. Sakshi Patil',
        designation: 'Intern, Infosys Hinjewadi',
        rating: [1, 1, 1, 1, 1],
        text: '“I felt completely at home here. The PG is secure, staff is friendly, and it’s super close to the Infosys gate. Highly recommended for female professionals.”',
    },
];

























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9209169761",
            "+91 9096665072",

        ],
        email: "reservation@swamisamarthpg.com "
    };


     const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " PG in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "  Single Room PG in Pune",
        },
        
        {
            place: "/images/keyword/4.jpg",
            text: "  Best Luxury PG in Pune",
        },
       
       
        {
            place: "/images/keyword/13.jpg",
            text: "  Hostel in Pune",
        },

        {
            place: "/images/keyword/15.jpg",
            text: " PG for Working Professionals Pune",
        },
        
        {
            place: "/images/keyword/19.jpg",
            text: "  Paying Guest Near Hinjewadi IT Park Pune",
        },
        

    ];


    const images = [
        { src: "./images/gallery/1.jpg", alt: "Image 1" },
        { src: "./images/gallery/2.jpg", alt: "Image 1" },
        { src: "./images/gallery/3.jpg", alt: "Image 1" },
        { src: "./images/gallery/4.jpg", alt: "Image 1" },
        { src: "./images/gallery/5.jpg", alt: "Image 1" },
        { src: "./images/gallery/6.jpg", alt: "Image 1" },
        { src: "./images/gallery/7.jpg", alt: "Image 1" },
        { src: "./images/gallery/8.jpg", alt: "Image 1" },
        { src: "./images/gallery/9.jpg", alt: "Image 1" },

    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best PG in Hinjewadi Phase 1 for Females with Food Near Infosys",
  "image": "https://swamisamarthpg.com/assets/images/best-pg-hinjewadi-phase1-females-food.jpg", // Replace with actual image URL
  "description": "Safe and fully furnished PG accommodations for females in Hinjewadi Phase 1 near Infosys. Includes veg and non-veg food options, ideal for female working professionals and students.",
  "brand": {
    "@type": "Brand",
    "name": "Shree Swami Samarth PG"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.95",
    "ratingCount": "1900"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "9800",  // Replace with actual price if needed
    "availability": "https://schema.org/InStock",
    "url": "https://swamisamarthpg.com/best-pg-hinjewadi-phase1-females-food"  // Replace with actual page URL if different
  }
};






    return (
        <div>


<Helmet>
  <title>Best PG in Hinjewadi Phase 1 for Females with Food Near Infosys</title>
  <meta 
    name="description" 
    content="Safe, furnished PG for females near Infosys Hinjewadi Phase 1 with veg/non-veg food options. Ideal for female working professionals and students." 
  />
  <meta 
    name="keywords" 
    content="Best PG for Females in Hinjewadi Phase 1, PG Near Infosys Hinjewadi for Girls, Ladies PG with Food in Hinjewadi Phase 1, Safe PG for Women Near Infosys Hinjewadi, Girls PG with Food Near Infosys Pune, Fully Furnished PG for Females in Phase 1 Hinjewadi, Affordable PG for Girls Near Infosys, PG with Veg/Non-Veg Food Near Infosys, PG for Female Working Professionals in Phase 1, Girls Hostel Near Infosys Hinjewadi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="page-title"
                style={{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(images/background/3.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: 'white'
  }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/21.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF6403', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topFacilities.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                          

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Shree Swami Samarth PG</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                {/* <FAQKeyword faqs={faqData} /> */}
                <Accordion data={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF6403',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF6403' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919209169761" className="d-block  text-white">+91 9209169761</a>
                                                <a href="tel:+919096665072" className="d-block  text-white">+91 9096665072</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:reservation@swamisamarthpg.com " className=" text-white d-block">
                                                    reservation@swamisamarthpg.com 
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Shree Swami Samarth PG  <br />
                                                        M.No. 03065, No. 258/1/3, Mukai Nagar, B.H. MRF Showroom, Pune 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bestpginhinjewadiphase;